// ... existing code ...
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LatestGrid from './components/LatestGrid';
import HotRanking from './components/HotRanking';
import CategoryNav from './components/CategoryNav';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <LatestGrid />
        <HotRanking />
        <CategoryNav />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
}